
import swiper from "@/js/swiper.js";
import components from "@/js/components";
import pages from './pages/index.js';
import menuHighlight from "@/js/menu_highlight";
import faq from "@/js/faq";
import forms from "@/js/forms";
import initRecaptcha from "@/js/recaptcha";

window.addEventListener("DOMContentLoaded", async () => {
    // deSVG("img[inline]", true);
    components();
    pages();
    swiper();
    menuHighlight();
    faq();
    forms();
    initRecaptcha();
});
